import { put, call, takeLatest, all, select } from 'redux-saga/effects'
import * as API from '../utils/Apis'
import * as ACTION from './bootstrapActions'
import * as CONST from './bootstrapConstants'

function* registration({ payload }) {
	try {
		const response = yield call(API.registrationApi, payload);
		yield put(ACTION.registrationSuccess(response?.data));
	} catch (err) {
		yield put(ACTION.registrationFailed(err?.response?.data));
	}
}

function* login({ payload }) {
	try {
		const response = yield call(API.loginApi, payload);
		yield put(ACTION.loginSuccess(response?.data));
	} catch (err) {
		yield put(ACTION.loginFailed(err?.response?.data));
	}
};

function* removeAccount({ payload }) {
	try {
		const response = yield call(API.removeAccountApi, payload);
		yield put(ACTION.removeAccountSuccess(response?.data));
	} catch (err) {
		yield put(ACTION.removeAccountFailed(err?.response?.data));
	}
};

function* clothesInquiry() {
	try {
		const response = yield call(API.clothesInquiryApi);
		yield put(ACTION.clothesInquirySuccess(response?.data));
	} catch (err) {
		yield put(ACTION.clothesInquiryFailed(err?.response?.data));
	}
};

function* clothesEntity({ payload }) {
	const { accessToken } = yield select(state => state);

	try {
		const response = yield call(API.clothesEntityApi, payload, accessToken);
		yield put(ACTION.clothesEntitySuccess(response?.data));
	} catch (err) {
		yield put(ACTION.clothesEntityFailed(err?.response?.data));
	}
};

function* clothesInsert({ payload }) {
	const { accessToken } = yield select((state) => state);

  try {
    const response = yield call(API.clothesInsertApi, payload, accessToken);
    yield put(ACTION.clothesInsertSuccess(response?.data));
  } catch (err) {
    yield put(ACTION.clothesInsertFailed(err?.response?.data));
  }
};

function* clothesUpdate({ payload }) {
	const { accessToken } = yield select((state) => state);

  try {
    const response = yield call(API.clothesUpdateApi, payload.params, payload.data, accessToken);
    yield put(ACTION.clothesUpdateSuccess(response?.data));
  } catch (err) {
    yield put(ACTION.clothesUpdateFailed(err?.response?.data));
  }
};

function* clothesDelete({ payload }) {
	const { accessToken } = yield select(state => state);

	try {
		const response = yield call(API.clothesDeleteApi, payload, accessToken);
		yield put(ACTION.clothesDeleteSuccess(response?.data));
	} catch (err) {
		yield put(ACTION.clothesDeleteFailed(err?.response?.data));
	}
}

const bootstrap = [
	takeLatest(CONST.REGISTRATION, registration),
	takeLatest(CONST.LOGIN, login),
	takeLatest(CONST.REMOVE_ACCOUNT, removeAccount),
	takeLatest(CONST.CLOTHES_INQUIRY, clothesInquiry),
	takeLatest(CONST.CLOTHES_ENTITY, clothesEntity),
	takeLatest(CONST.CLOTHES_INSERT, clothesInsert),
	takeLatest(CONST.CLOTHES_UPDATE, clothesUpdate),
	takeLatest(CONST.CLOTHES_DELETE, clothesDelete),
];

export default function* bootstrapSaga() {
	yield all([...bootstrap])
}